import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const getShifts = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/shifts`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const uploadSchedule = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/upload-schedule`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
